import { Component, inject } from "@angular/core";
import { WorkflowTableComponent } from "../workflow-table/workflow-table.component";
import { IWorkflow } from "../../interfaces/i-workflow";
import { ApiService } from "../../../../services/api.service";
import { AlertService } from "../../../../shared/alert/alert.service";
import { SpinnerService } from "../../../../shared/spinner/spinner.service";
import { AlertEnum } from "../../../../shared/alert/alert.enum";
import { MatButton } from "@angular/material/button";
import { AutomationAction, AutomationType } from "../../enums/automation.enum";
import { AutomationUtilityService } from "../../services/automation-utility.service";

@Component({
  selector: "app-workflow-manager",
  imports: [
    WorkflowTableComponent,
    MatButton
  ],
  providers: [
    AutomationUtilityService
  ],
  templateUrl: "./workflow-manager.component.html",
  styleUrl: "./workflow-manager.component.scss",
})
export class WorkflowManagerComponent {
  gridData: IWorkflow[] = [];
  isLoading = true;

  #apiService = inject(ApiService);
  #alertService = inject(AlertService);
  #spinnerService = inject(SpinnerService);
  #automationUtilityService = inject(AutomationUtilityService);

  constructor() {
    // API call to get workflows
    this.#spinnerService.show();
    this.#apiService.getAllWorkflows().subscribe({
      next: workflows => {
        this.gridData = workflows;
        this.#spinnerService.hide();
        this.isLoading = false;
      },
      error: (error: any) => {
        this.#spinnerService.hide();
        this.#alertService.showAlert({
          message: `Failed to get all workflows.`,
          type: AlertEnum.error,
        });
        this.isLoading = false;
      }
    });
  }

  onCreate(): void {
    this.#automationUtilityService.createItem(AutomationType.WORKFLOW, AutomationAction.CREATE);
  }
}
